var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useContext } from "react";
import Input from "../input/Input";
import Checkbox from "../checkbox/Checkbox";
import Toggle from "../toggle/Toggle";
import Select from "../select/Select";
import { isGroupParent } from "./TableGroupingColumn";
import { TableDataContext } from "./Table";
import { isTableFillerType } from "./TableFillerColumn";
import { updateFieldAtRowIndex, valueToString, StopPropagation } from "./TableCellContentUtils";
import useIdAttrs from "../../hooks/useIdAttrs";
export { updateFieldAtRowIndex, valueToString, StopPropagation };
const TableCellContentInner = (cellRendererParams) => {
    const { id, insightsAttr, dataItem, dataIndex, value, valueFormatted, field, onDataChange, column } = cellRendererParams;
    const idAttrs = useIdAttrs({ id, insightsAttr });
    const [inputValue, setInputValue] = useState(value);
    const [error, setError] = useState();
    const { editMode, editModeSelectOptions = [], getEditModeCellProps, type, cellRenderer } = column;
    const isGroupParentCell = isGroupParent(dataItem);
    const _a = (getEditModeCellProps === null || getEditModeCellProps === void 0 ? void 0 : getEditModeCellProps(cellRendererParams)) || {}, { isValid } = _a, editModeProps = __rest(_a, ["isValid"]);
    const tableDataRef = useContext(TableDataContext);
    if (!field || isGroupParentCell || !editMode) {
        return React.createElement("span", { tabIndex: isTableFillerType(type) || cellRenderer ? undefined : 0 }, valueFormatted);
    }
    const callOnChange = (newValue) => {
        onDataChange(updateFieldAtRowIndex(tableDataRef === null || tableDataRef === void 0 ? void 0 : tableDataRef.current, dataIndex, field, newValue));
    };
    const validate = (input, callback) => {
        callback === null || callback === void 0 ? void 0 : callback(input);
        if (!isValid) {
            return;
        }
        const valueError = !isValid(input);
        setError(valueError);
    };
    const onBlurInput = (e) => {
        if (value === inputValue) {
            return;
        }
        // use validated number from onBlurHandler as number input
        const input = (editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.type) === "number" ? e.currentTarget.value : inputValue;
        // we need to postpone the data change, therefore the re-render
        // to after the next element is focused
        setTimeout(() => {
            callOnChange(input);
        });
    };
    useEffect(() => {
        validate(value, setInputValue);
    }, [value]);
    switch (editMode) {
        case "input":
            return (React.createElement(StopPropagation, { stopHorizontalNavigation: true, stopVerticalNavigation: (editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.type) === "number" },
                React.createElement(Input, Object.assign({ value: valueToString(inputValue) }, idAttrs("input-", { prepend: true }), { name: `${field}-${id}`, onChange: (e) => validate(e.target.value, setInputValue), onBlur: onBlurInput, error: error }, editModeProps))));
        case "checkbox":
            return (React.createElement(StopPropagation, null,
                React.createElement(Checkbox, Object.assign({ display: "inline" }, idAttrs("input-checkbox-", { prepend: true }), { name: `${field}-${id}`, checked: Boolean(inputValue), onChange: (e) => validate(e.target.checked, callOnChange), disabled: editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.disabled, error: error }, editModeProps))));
        case "toggle":
            return (React.createElement(StopPropagation, null,
                React.createElement(Toggle, Object.assign({}, idAttrs("input-toggle-", { prepend: true }), { name: `${field}-${id}`, checked: Boolean(inputValue), onChange: (newValue) => validate(newValue, callOnChange) }, editModeProps, { size: (editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.size) === "normal" ? "small" : editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.size }))));
        case "select":
            return (React.createElement(StopPropagation, null,
                React.createElement(Select, Object.assign({}, idAttrs("input-select-", { prepend: true }), { name: `${field}-${id}`, width: "100%", options: editModeSelectOptions, currentValue: String(inputValue), onChange: (option) => validate((option === null || option === void 0 ? void 0 : option.value) || "", callOnChange), error: error, isDisabled: editModeProps === null || editModeProps === void 0 ? void 0 : editModeProps.disabled }, editModeProps))));
        default:
            // because Sonar :)
            return null;
    }
};
const TableCellContent = (cellRendererParams) => {
    const { column: { cellRenderer }, } = cellRendererParams;
    const tableDataRef = useContext(TableDataContext);
    if (cellRenderer) {
        return (React.createElement(React.Fragment, null, cellRenderer(Object.assign(Object.assign({}, cellRendererParams), { data: tableDataRef === null || tableDataRef === void 0 ? void 0 : tableDataRef.current, originalContent: React.createElement(TableCellContentInner, Object.assign({}, cellRendererParams)) }))));
    }
    return React.createElement(TableCellContentInner, Object.assign({}, cellRendererParams));
};
export default TableCellContent;
//# sourceMappingURL=TableCellContent.js.map